import Vue from 'vue'

export default {
  create(payload) {
    return Vue.http.post('integration', payload)
  },
  update(payload) {
    return Vue.http.post('integration/update', payload)
  },
  createIntegration({ companyId, integrationProviderId, locationId, ...payload }) {
    return Vue.http.post(
      `app-services/v2/integration/${companyId}/${locationId}/${integrationProviderId}`,
      payload
    )
  },
  updateIntegration({ integrationId, payload }) {
    return Vue.http.put(`app-services/v2/integration/${integrationId}`, payload)
  },
  updateIntegrationOauth(payload) {
    return Vue.http.put('app-services/v2/integration/oauth', payload)
  },
  getIntegration(integrationId) {
    return Vue.http.get(`app-services/v2/integration/${integrationId}`)
  },
  listIntegrations(payload) {
    return Vue.http.post(`app-services/v2/integration/list`, payload)
  },
  getChowNowLocations({ companyId }) {
    return Vue.http.get(`app-services/v2/integration/chownow/${companyId}/locations`)
  },
  getOauthAccountLocations({ companyId, integrationProviderName, oAuthName }) {
    return Vue.http.get(
      `app-services/v2/integration/${integrationProviderName}/${companyId}/locations?oAuthName=${oAuthName}`
    )
  },
  getQuLocations({ companyId }) {
    return Vue.http.get(`app-services/v2/integrations/qu/${companyId}/locations`)
  },
  getSimphonyLocations({ companyId }) {
    return Vue.http.get(`app-services/v2/integrations/simphony/${companyId}/locations`)
  },
  setSpotOnBlid({ locationId, blid }) {
    return Vue.http.put(
      `spoton/v1/locations/${locationId}/spoton-blid`,
      { blid },
      { headers: { 'X-Ovation-Scope': `location/${locationId}` } }
    )
  }
}
